import React from "react";
import save from "./logo_save.png";
import oikos from "./logo-oikos.png";
import loghi from "./loghi.png";

import {Wrap, Space} from "./styles";

export default function Footer(props) {
  return (
    <Wrap>
      <div>
        <div>
          <h1>UN PROGETTO DI:</h1>
          <div className="primo">
            <img width="250" height="51" alt="save" src={save} />
            <Space />
            <img width="89" height="78" alt="oikos" src={oikos} />
          </div>
        </div>
        <div>
          <h1>CON IL SUPPORTO DI:</h1>
          <div>
            <img width="533" height="100" alt="loghi" src={loghi} />
          </div>
        </div>
      </div>
      <div>
        <p>
          Realizzato nell’ambito del progetto Children Stand Up.
          <br />
          Il progetto è parte dell’European Climate Initiative (EUKI) del Ministero federale tedesco per l'ambiente, la
          conservazione della natura e la sicurezza nucleare (BMU).
          <br />
          L'autore è il solo responsabile di questa pubblicazione e le informazioni contenute non riflettono
          necessariamente le opinioni del Ministero.
        </p>
      </div>
    </Wrap>
  );
}
